const endpoints  = {
    agent: {
      login: '/login',
      usersList: '/usersList',
      userDetail: '/userDetail',
      userCreate: '/userCreate',
      userSuspend: '/userSuspend',
      userAmountAdjust: '/userAdjust',
      userResetPassword: "/resetPassword",
      getUserTrnx: '/userTrnx',
      getMatchLog: "/matchLog",
      getMatchLogLatest: "/matchLogLatest",
      getAgentAmount: "/getAgentAmount",
      getDashboardData: "/dashboard",
      getDepositAndWithdrawUsers: "/depositAndWithdrawUsers"
    }
} ;


export default endpoints;